/*
 * Copyright (c) 2026. Bluemate B.V.
 */
import './style/connectSteps.scss';

import classNames from 'classnames';

import React from 'react';

interface Props {
    current: 1 | 2 | 3;
    labels: [string, string, string];
    className?: string;
}

// The three-step progress bar of the MCP connect hand-off. The same markup and
// classes are rendered server-side on the MCP consent page (the SCSS is
// vendored there), so the bar looks identical across both services.
export default function ConnectSteps(props: Props) {
    const {current, labels, className} = props;

    return (
        <div className={classNames('connect-steps', className)}>
            {labels.map((label, index) => {
                const step = index + 1;
                const state = step < current ? 'done' : step === current ? 'active' : 'upcoming';
                return (
                    <React.Fragment key={label}>
                        {index > 0 && <div className={classNames('connect-steps-bar', step <= current && 'filled')} />}
                        <div className={classNames('connect-step', state)}>
                            <span className='connect-step-dot'>{state === 'done' ? '✓' : step}</span>
                            <span className='connect-step-label'>{label}</span>
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
}
